<template>
  <el-dialog
    title="提示"
    :visible.sync="dialogVisible"
    width="310px">
    <div class="personnel">
      <div class="personnel-left">
        <HrTree @nodeClick="onHrTree" height="calc(50vh - 40px)" />
      </div>
    </div>
    <div class="personnel-footer">
      <el-button size="mini" type="info" @click="closeFun">取 消</el-button>
      <el-button size="mini" type="primary" @click="confirmFun">确 定</el-button>
    </div>
  </el-dialog>

</template>

<script>
import HrTree from "./HrTree";
export default {
  name: "selectDepartment",
  components: {HrTree},
  data(){
    return {
      where_personnel_type:"hr_tree",
      dialogVisible:false,
      loading:false,
      callback_fun:null,
      disabled:false,
      selectDepartment: {},
    }
  },
  mounted() {

  },
  methods:{
    show({},callback_fun){
      const that = this;
      that.dialogVisible = true;
      if(typeof callback_fun === "function"){
        that.callback_fun = callback_fun;
      }
    },
    confirmFun(){
      if(typeof this.callback_fun === "function"){
        this.callback_fun(this.selectDepartment);
        this.callback_fun=undefined;
      }
      this.dialogVisible=false;
    },
    closeFun(){
      if(typeof this.callback_fun === "function"){
        this.callback_fun=undefined;
      }
      this.dialogVisible=false;
    },
    onHrTree(data){
      this.selectDepartment = data;
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../common";
.personnel{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  .personnel-left{
    width: 500px;
    height: 50vh;
    //overflow-y: scroll;

    .user_role_body{
      .user_role_body_item{
        color: #6f7175;
        width: 100%;
        cursor: pointer;
        padding: 2px 0 2px 5px;
        margin: 2px 0;
        &:hover{
          background-color: #e8e8e8;
        }
        &:active{
          background-color: #b2c7d0;
        }
        &.active{
          background-color: #b2c7d0;
        }
      }
    }
  }
  .personnel-right{
    margin-left: 5px;
    height: 100%;
  }
}
.personnel-footer{
  margin-top: 10px;
  width: 100%;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Personnel/components/selectDepartment.vue